import { differenceInHours } from "date-fns";

export const SLA_HOURS = 72;

export const isOverSla = (receivedAt: string): boolean => {
    const received = new Date(receivedAt);

    if (Number.isNaN(received.getTime())) {
        return false;
    }

    return differenceInHours(new Date(), received) >= SLA_HOURS;
};
